// ไฟล์: frontend/src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/auth';

function Header() {
  const currentUser = authService.getCurrentUser();
  
  // ฟังก์ชั่นล็อกเอาต์
  const handleLogout = () => {
    authService.logout();
  };
  
  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      {/* Left navbar links */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="#" role="button">
            <i className="fas fa-bars"></i>
          </a>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <Link 
            to={authService.isAdmin() ? "/admin/dashboard" : "/teacher/dashboard"} 
            className="nav-link"
          >
            หน้าหลัก
          </Link>
        </li>
        {authService.isAdmin() && (
          <>
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/admin/students" className="nav-link">นักเรียน</Link>
            </li>
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/admin/classes" className="nav-link">ชั้นเรียน</Link>
            </li>
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/admin/teachers" className="nav-link">ครูผู้สอน</Link>
            </li>
          </>
        )}
        {authService.isTeacher() && (
          <>
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/teacher/attendance" className="nav-link">บันทึกการเข้าเรียน</Link>
            </li>
            <li className="nav-item d-none d-sm-inline-block">
      <Link to="/teacher/growth" className="nav-link">น้ำหนัก/ส่วนสูง</Link>
    </li>
    <li className="nav-item d-none d-sm-inline-block">
      <Link to="/teacher/growth/reports" className="nav-link">รายงานน้ำหนัก</Link>
    </li>
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/teacher/reports" className="nav-link">รายงานการมาเรียน</Link>
            </li>
          </>
        )}
      </ul>

      {/* Right navbar links */}
      <ul className="navbar-nav ml-auto">
        <li className="nav-item dropdown">
          <a className="nav-link" data-toggle="dropdown" href="#">
            <i className="far fa-user"></i>
            <span className="ml-1">{currentUser?.first_name} {currentUser?.last_name}</span>
          </a>
          <div className="dropdown-menu dropdown-menu-right">
            <Link 
              to={authService.isAdmin() ? "/admin/profile" : "/teacher/profile"} 
              className="dropdown-item"
            >
              <i className="fas fa-user-cog mr-2"></i> ข้อมูลส่วนตัว
            </Link>
            <div className="dropdown-divider"></div>
            <button onClick={handleLogout} className="dropdown-item">
              <i className="fas fa-sign-out-alt mr-2"></i> ออกจากระบบ
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default Header;